<template>
  <warning-modal
    class="inform-modal"
    name="inaccessible-pads-inform-modal"
    :title="$t('dashboard.warning.unavailableProducts.title')"
    large-screen-width="460"
    @before-open="onBeforeOpen"
  >
  <template #main-content>
      <p>
        {{ $t('dashboard.warning.unavailableProducts.description') }}
      </p>
  </template>

    <template #actions>
      <button
        class="rounded-button-white"
        :class="{ 'rounded-button-white__alma': isAlmaTerritory }"
        @click="handleClose(true)"
      >
        {{ $t('dashboard.button.ok') }}
      </button>
    </template>
  </warning-modal>
</template>

<script>
import WarningModal from '@/modules/dashboard/components/common/warning-modal/WarningModal.vue';
import isAlmaTerritories from '@/modules/dashboard/components/mixins/isAlmaTerritories';

export default {
  name: 'InaccessiblePadsInformModal',
  components: { WarningModal },
  mixins: [isAlmaTerritories],
  data() {
    return { onClose: null };
  },
  methods: {
    onBeforeOpen({ params: { onClose } }) {
      this.onClose = onClose;
    },
    handleClose(confirm) {
      this.onClose({ confirm });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/common/buttons.scss';
</style>
